import Accordion from '../Accordion';

export default class StaticPageFaq {
  constructor(section) {
    this.$el = $(section.el);
    this.$accordionToggle = this.$el.find('[data-accordion-toggle]');

    this.Accordion = new Accordion(this.$el, {
      activeClass: 'active',
      content: '[data-accordion-content]'
    });

    this.events = [
      this.$accordionToggle.on(
        'click.static-page-faq',
        this._toggleFaq.bind(this)
      )
    ];
  }

  _toggleFaq(event) {
    const $target = $(event.currentTarget);
    const $faq = $target.closest('[data-accordion-content]');

    this.Accordion.toggle($faq);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.static-page-faq'));
  }
}
